import React from "react";
import { CardConditionEnum } from "modules/cards/model/card";
import {
  cardConditionStrings,
  cardConditionStringsFull,
} from "modules/common/model/models";
import { cn } from "utils/utils";

interface ConditionChipProps {
  condition: CardConditionEnum;
  size?: "sm" | "md";
  showMinimum?: boolean;
}

const conditionTooltipMap: Record<CardConditionEnum, string> = {
  [CardConditionEnum._]: "",
  [CardConditionEnum.Poor]: "tooltip-condition-poor",
  [CardConditionEnum.Played]: "tooltip-condition-played",
  [CardConditionEnum.LightPlayed]: "tooltip-condition-light-played",
  [CardConditionEnum.Good]: "tooltip-condition-good",
  [CardConditionEnum.Excellent]: "tooltip-condition-excellent",
  [CardConditionEnum.NearMint]: "tooltip-condition-near-mint",
  [CardConditionEnum.Mint]: "tooltip-condition-mint",
};

const conditionBadgeMap: Record<CardConditionEnum, string> = {
  [CardConditionEnum._]: "bg-gray-500 text-white",
  [CardConditionEnum.Poor]: "bg-card-condition-poor text-black",
  [CardConditionEnum.Played]: "bg-card-condition-played text-black",
  [CardConditionEnum.LightPlayed]: "bg-card-condition-light-played text-black",
  [CardConditionEnum.Good]: "bg-card-condition-good text-black",
  [CardConditionEnum.Excellent]: "bg-card-condition-excellent text-black",
  [CardConditionEnum.NearMint]: "bg-card-condition-near-mint text-black",
  [CardConditionEnum.Mint]: "bg-card-condition-mint text-black",
};

const ConditionChip: React.FC<ConditionChipProps> = ({
  condition,
  size = "md",
  showMinimum = false,
}) => {
  const tooltipClass = conditionTooltipMap[condition] || "";
  const badgeClass =
    conditionBadgeMap[condition] || "bg-neutral text-neutral-content";

  return (
    <div className="flex items-center justify-center">
      <div
        className={cn("tooltip", tooltipClass)}
        data-tip={
          showMinimum && condition !== CardConditionEnum.Mint
            ? `Minimum ${cardConditionStringsFull[condition]}`
            : cardConditionStringsFull[condition]
        }
      >
        <span
          className={cn(
            "badge justify-center gap-0.5",
            size === "sm"
              ? "badge-xs min-w-[28px] text-xs"
              : "min-w-[40px] text-sm",
            badgeClass
          )}
        >
          {showMinimum && condition !== CardConditionEnum.Mint && (
            <span className="text-base">≥</span>
          )}
          {cardConditionStrings[condition]}
        </span>
      </div>
    </div>
  );
};

export default ConditionChip;
